export function includesPath(path: string, match: string): boolean {
  return path === match || path.includes(match)
}

export function matchesPath(path: string, match: string): boolean {
  return path === match
}

export function sanitizeRedirect(url: string, fallback = '/') {
  return isLocalUrl(url) || isPermittedUrl(url) ? url : fallback
}

export function isLocalUrl(url: string) {
  // When constructing a URL object with a string that starts with `//`, the URL constructor
  // will treat it as a protocol-relative URL, which would allow user input to lead to a redirect to another domain. Yikes!
  if (url.startsWith('//')) {
    return false
  }

  return url.startsWith('/') || url.startsWith('#') || url.startsWith('?')
}

const allowedTlds = [
  'localhost',
  '.infura.io',
  '.infuratest.io',
  '.metamask.io',
  'metamask-web.vercel.app',
  ...(process.env.VERCEL ? [`.${process.env.NEXT_PUBLIC_VERCEL_URL}`] : [])
]

export function isPermittedUrl(url: string) {
  try {
    const u = new URL(url)
    if (!u.host.startsWith('.')) u.host = `.${u.host}`
    return allowedTlds.some(tld => u.host.split(':')[0].endsWith(tld))
  } catch (_) {
    return false
  }
}
